import ReactDOMServer from "react-dom/server";

import { PieceResponseDTO } from "../../../openapi-generated-client";
import "./pieceInfoGroup.css";

interface PieceInfoGroupProps {
    piece: PieceResponseDTO;
}

export default function PieceInfoGroup(props: {children: any, fullWidth?: boolean, id?: string}) {
    var hasChildren = Boolean(ReactDOMServer.renderToStaticMarkup(props.children));
    if(!hasChildren) return <></>;
    return <div id={props.id ? props.id : ""} className={"piece-info-group" + (props.fullWidth ? " full-width" : "")}>
        <hr/>
        {props.children}
    </div>;
};

export type { PieceInfoGroupProps };
